var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "quote-popup" }, [
    _c(
      "button",
      {
        staticClass: "quote-popup__toggle",
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.toggleModal.apply(null, arguments)
          },
        },
      },
      [_vm._v("\n        " + _vm._s(_vm.buttonLabel) + "\n    ")]
    ),
    _vm._v(" "),
    _vm.modalOpen
      ? _c(
          "div",
          {
            staticClass: "quote-popup__modal showing",
            class: { "quote-popup--pull-up": _vm.isDiscountPresent },
          },
          [
            _c("table", [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.calculation.lineItems, function (item, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [_vm._v(_vm._s(item.charges))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm._f("toCurrency")(item.wholesale, 2))),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm._f("toCurrency")(item.retail, 2))),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm._f("toCurrency")(item.estimates, 2))),
                    ]),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _vm.calculation.discount > 0
                  ? _c("tr", [
                      _c("th", { attrs: { colspan: "3" } }, [
                        _vm._v(
                          " \n                        Contract discount\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          "\n                        - " +
                            _vm._s(
                              _vm._f("toCurrency")(_vm.calculation.discount, 2)
                            ) +
                            "\n                    "
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("tr", [
                  _c("th", { attrs: { colspan: "3" } }, [
                    _vm._v(
                      "\n                        Total estimated annual charges\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm._f("toCurrency")(_vm.calculation.total, 2)) +
                        "\n                    "
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Charges")]),
        _vm._v(" "),
        _c("th", [_vm._v("Wholesale")]),
        _vm._v(" "),
        _c("th", [_vm._v("Retail")]),
        _vm._v(" "),
        _c("th", [_vm._v("Estimate")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }